import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { autoUpdate, flip, FloatingPortal, offset, shift, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole } from "@floating-ui/react-dom-interactions";
import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
const Underline = tw.span`
  decoration-dashed
  decoration-1
  decoration-[#333333]
  underline-offset-[3px]
`;
const BaseContainerStyles = `
  rounded-md
  border
  border-white
  py-1.5
  px-2.5
  text-sm
  max-w-[350px]
`;
const TypeStyles = {
    default: `
    border-white/7
    bg-grayscale-darker/30
    backdrop-blur-xl
    text-white
  `,
    warning: `
    border-opacity-80
    bg-alert-background
    text-alert-primary
    cursor-not-allowed
  `
};
const SizeStyles = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-base"
};
const STooltip = ({ children, content, placement = "top", width = "max-content", type = "default", size = "sm", underline = true, delay = 0, zIndex = 11, open: _open = false })=>{
    const [open, setOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    // const onSetOpen = useCallback(
    //   (val: boolean) => {
    //     if (val) {
    //       setTimeout(() => {
    //         setOpen(val)
    //       }, delay)
    //     } else {
    //       setOpen(val)
    //     }
    //   },
    //   [delay]
    // )
    const { x, y, reference, floating, strategy, context } = useFloating({
        open,
        // onOpenChange: delay == 0 ? setOpen : onSetOpen,
        placement: placement,
        // Make sure the tooltip stays on the screen
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(5),
            flip(),
            shift()
        ]
    });
    // Event listeners to change the open state
    const hover = useHover(context, {
        move: false
    });
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    // Role props for screen readers
    const role = useRole(context, {
        role: "tooltip"
    });
    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        focus,
        dismiss,
        role
    ]);
    const containerStyles = `${BaseContainerStyles} ${TypeStyles[type]} ${SizeStyles[size]}`;
    useEffect(()=>{
        let timer;
        if (isHovered) {
            timer = setTimeout(()=>{
                setOpen(true);
            }, delay);
        } else {
            setOpen(false);
        }
        return ()=>{
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [
        isHovered,
        delay
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            underline ? /*#__PURE__*/ _jsx("span", {
                ref: reference,
                ...getReferenceProps(),
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                style: {
                    textDecoration: "underline dashed",
                    textDecorationColor: "#333333",
                    textUnderlineOffset: "3px"
                },
                children: children
            }) : /*#__PURE__*/ _jsx("span", {
                ref: reference,
                ...getReferenceProps(),
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: children
            }),
            /*#__PURE__*/ _jsx(FloatingPortal, {
                children: open && /*#__PURE__*/ _jsx("div", {
                    ref: floating,
                    className: containerStyles,
                    style: {
                        // Positioning styles
                        position: strategy,
                        top: y ?? 0,
                        zIndex,
                        left: x ?? 0,
                        width: width
                    },
                    ...getFloatingProps(),
                    children: content
                })
            })
        ]
    });
};
export default STooltip;
